import React from 'react';
import {Inert} from '@albert-io/atomic';

interface Props extends PropsWithChildrenRequired {
  interactive?: boolean;
}

const InteractivityHandler = ({interactive = true, children}: Props) => {
  return <Inert disabled={interactive}>{children}</Inert>;
};

export default InteractivityHandler;
